<p-toast position="top-right"></p-toast>
<fieldset [ngClass]="classeModeApplication">
	<legend>{{'SIGALE_ANGULAR.COMPONENTS.TRADUCTION.TITRE_RECHARGER_LEGEND' | translate}}</legend>
	<hr *ngIf="!modeApplicationCohabitation">
	<div class="col">
		<div>{{'SIGALE_ANGULAR.COMPONENTS.TRADUCTION.MESSAGE_RECHARGER' | translate}}</div>
		<button *ngIf="!modeApplicationCohabitation" pButton
				class="float-right bouton-admin btn"
				icon="pi pi-download"
				[title]="'SIGALE_ANGULAR.COMPONENTS.TRADUCTION.TITLE_BTN_RECHARGER' | translate"
				(click)="peuplerCacheTraduction()"
				[label]="'SIGALE_ANGULAR.COMPONENTS.TRADUCTION.BTN_RECHARGER_CACHE' | translate">
		</button>
		<button *ngIf="modeApplicationCohabitation" type="button"
				class="btn btn-medium float-right btn btn-medium action-button pull-right"
				title="{{'SIGALE_ANGULAR.COMPONENTS.TRADUCTION.TITLE_BTN_RECHARGER' | translate}}"
				(click)="peuplerCacheTraduction()">
			<em class="pi pi-download"></em> {{'SIGALE_ANGULAR.COMPONENTS.TRADUCTION.BTN_RECHARGER_CACHE' | translate}}
		</button>
	</div>
</fieldset>
